<template>
  <v-app class="my-application">
    <TopNavigation></TopNavigation>
    <v-main>
      <PageLoader v-if="loader"></PageLoader>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import PageLoader from "./components/Dialogs/PageLoader.vue";
import TopNavigation from "./components/Navigation/TopNavigation.vue";
import { Device } from "@capacitor/device";
import { mapMutations, mapState } from "vuex";
import { SafeArea } from "capacitor-plugin-safe-area";
import axios from "axios";
import { StatusBar, Style } from "@capacitor/status-bar";

export default {
  components: {
    TopNavigation,
    PageLoader,
  },

  async created() {
    try {
      const info = await Device.getInfo();
      if (info.platform == "ios") {
        await StatusBar.setStyle({ style: Style.Dark });

        SafeArea.getSafeAreaInsets().then(({ insets }) => {
          this.setInsets(insets);
        });
      }

      // if (info.platform !== "web") {
      //   const delegate = new window.cordova.plugins.locationManager.Delegate();
      //   window.cordova.plugins.locationManager.setDelegate(delegate);
      // }

      if (this.$store.state.base.mobileLang == null) {
        const code = await Device.getLanguageCode();
        this.setMobileLang(code.value.split("-")[0]);
        this.$i18n.locale = code.value.split("-")[0];
      } else {
        this.$i18n.locale = this.mobileLang.code;
      }
      axios.defaults.headers.common[
        "Accept-Language"
      ] = `${this.mobileLang.code}`;

      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      batteryLevel: null,
      eventLocation: null,
      location: null,
      loader: true,
    };
  },

  computed: {
    ...mapState({
      mobileLang: (state) => state.base.mobileLang,
      insets: (state) => state.base.insets,
      base_url: (state) => state.base.base_url,
    }),

    main() {
      return {
        padding: `${this.insets?.top}px 0px 0px 0px`,
      };
    },
  },

  methods: {
    ...mapMutations(["setMobileLang", "getLocation", "setInsets"]),
  },
};
</script>

<style lang="scss">
//======VUETIFY OVERRIDES========

html {
  padding: 0;
  margin: 0;
  scrollbar-width: none;
}
.v-main__wrap {
  display: flex;

  // background-color: #2b4c59 !important;
}

.v-toolbar__content {
  padding: 10px !important;
  justify-content: space-between !important;
  flex-grow: 1;
}

.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 25px !important;
} //search input height

.v-icon.notranslate.mdi.mdi-circle-outline.theme--light {
  color: white !important;
} //checkbox color when unchecked

//======GLOBAL STYLES=======
.component-wrapper {
  flex-grow: 1;
  // padding-top: 10px;
}

@import url("https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@100;300;400;500;700&display=swap");

@font-face {
  font-family: "objektiv-mk1";
  src: url("./assets/fonts/Objektiv Mk1 Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "objektiv-mk1";
  src: url("./assets/fonts/Objektiv Mk1 Medium.ttf") format("truetype");
  font-weight: medium;
  font-style: normal;
}
@font-face {
  font-family: "objektiv-mk1";
  src: url("./assets/fonts/Objektiv Mk1 Bold.ttf") format("truetype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "objektiv-mk1";
  src: url("./assets/fonts/Objektiv Mk1 Thin.ttf") format("truetype");
  font-weight: thin;
  font-style: normal;
}
@font-face {
  font-family: "objektiv-mk1";
  src: url("./assets/fonts/Objektiv Mk1 Light.ttf") format("truetype");
  font-weight: light;
  font-style: normal;
}

$font-family-main: "objektiv-mk1", sans-serif;
$font-family-title: "Noto Serif Display", serif;

.my-application {
  *:not(.v-icon),
  *:not(.v-icon):before,
  *:not(.v-icon):after {
    font-family: $font-family-main !important;
  }

  .title-text {
    font-family: $font-family-title !important;
  }

  //transition styles
  .fade-enter-active {
    transition: all 0.6s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    // transition: all 0.6s;
  }

  .fade-page {
    transition: all 3s;
  }

  //transition styles
  .fade-page-enter-active,
  .fade-page-leave-active {
    transition: all 0.6s;
  }

  .fade-page-leave-to {
    opacity: 0.4;
    transition: all 0.6s;

    // transition: all 0.6s;
  }
}

.v-btn {
  text-transform: none !important;
}

.absolute-content {
  position: fixed;
  top: -56px;
  bottom: 0;
  width: 100%;
  z-index: 0;
  overflow-y: auto;
}

.bar-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
